import { z } from 'zod';

/**
 * @aiPurpose closed catalog of typed events on the Deal activity feed
 *   (#1087). Append-only — feed rows reference these literals forever.
 *   Mirrors the Prisma `DealActivityKind` enum 1:1.
 * @aiInvariant adding a kind requires a paired migration update; never
 *   remove or rename an existing kind.
 */
export enum DealActivityKind {
  DEAL_CREATED = 'DEAL_CREATED',
  DEAL_STAGE_CHANGED = 'DEAL_STAGE_CHANGED',
  DEAL_WON = 'DEAL_WON',
  DEAL_LOST = 'DEAL_LOST',
  DEAL_ASSIGNED = 'DEAL_ASSIGNED',
  DEAL_UNASSIGNED = 'DEAL_UNASSIGNED',
  DEAL_CLIENT_BOUND = 'DEAL_CLIENT_BOUND',
  DEAL_LEAD_BOUND = 'DEAL_LEAD_BOUND',
  DEAL_LEAD_UNBOUND = 'DEAL_LEAD_UNBOUND',
  DEAL_REQUEST_LINKED = 'DEAL_REQUEST_LINKED',
  DEAL_REQUEST_UNLINKED = 'DEAL_REQUEST_UNLINKED',
  DEAL_ARCHIVED = 'DEAL_ARCHIVED',
  DEAL_RESTORED = 'DEAL_RESTORED',
}
export const DealActivityKindSchema = z.nativeEnum(DealActivityKind);

/**
 * @aiPurpose wire projection of a `DealActivity` row.
 * @aiPii `metadata` carries entity ids and typed deltas only; never
 *   PII snapshots. Display names resolve at read time subject to actor
 *   visibility (mirrors the Lead activity invariant).
 */
export const DealActivitySchema = z
  .object({
    id: z.string().uuid(),
    dealId: z.string().uuid(),
    actorId: z.string().uuid().nullable(),
    kind: DealActivityKindSchema,
    metadata: z.record(z.unknown()),
    occurredAt: z.string().datetime(),
  })
  .strict();
export type DealActivity = z.infer<typeof DealActivitySchema>;
